import React from 'react';
import styled from 'styled-components';

export const Skeleton = () => (
  <Container>
    <Switchers>
      <DepartureSwitcher />
      <FirstSwitcher />
      <Switcher />
      <Switcher />
      <LastSwitcher />
    </Switchers>

    <ChartWrapper>
      <Tabs>
        <ActiveTab />
        <Tab />
        <Tab />
        <Tab />
        <Tab />
        <Tab />
      </Tabs>
      <Chart>
        <Preloader />
      </Chart>
    </ChartWrapper>
  </Container>
);

const PseudoContent = `
  display: flex;
  align-items: center;
  &::after {
    content: ' ';
    width: 65%;
    height: 16px;
    background-color: #ededed;
    border-radius: 3px;
    display: block;
    margin: 0 auto;
  };
`;

const ChartLine = `
  content: ' ';
  width: 100%;
  height: 1px;
  background-color: #dfdfdf;
  position: absolute;
`;

const Container = styled.div`
  max-width: 1176px;
`;

const Switchers = styled.div`
  display: flex;
  justify-content: center;
  margin-bottom: 40px;
`;

const Switcher = styled.div`
  flex-basis: 101px;
  height: 38px;
  background-color: #ffffff;
  border: 1px solid #cccccc;
  border-left-width: 0;

  ${PseudoContent}
`;

const DepartureSwitcher = styled(Switcher)`
  margin-right: 45px;
  flex-basis: 173px;
  border-left-width: 1px;
  border-radius: 4px;
`;

const FirstSwitcher = styled(Switcher)`
  border-top-left-radius: 4px;
  border-bottom-left-radius: 4px;
  border-left-width: 1px;
`;

const LastSwitcher = styled(Switcher)`
  border-top-right-radius: 4px;
  border-bottom-right-radius: 4px;
  border-right-width: 1px;
`;

const ChartWrapper = styled.div`
  background-color: #ffffff;
  box-shadow: 0px 1px 1px 0px rgba(0, 0, 0, 0.28);
  height: 356px;
`;

const Chart = styled.div`
  position: relative;
  margin: 0 110px;
  height: 330px;

  &::before {
    ${ChartLine};
    top: 100px;
  }
  &::after {
    ${ChartLine};
    top: 200px;
  }
`;

const Tabs = styled.div`
  display: flex;
`;

const Tab = styled.div`
  flex-basis: 197px;
  height: 46px;
  background-color: #f5f5f5;
  border: 1px solid #cccccc;
  box-sizing: border-box;
  margin-right: -1px;

  ${PseudoContent}
`;

const ActiveTab = styled(Tab)`
  background-color: inherit;
  border-bottom: 0;
  border-left: 0;
`;

const Preloader = styled.div`
  top: 50%;
  left: 50%;
  z-index: 1;
  content: '';
  width: 30px;
  height: 30px;
  position: absolute;
  margin-top: -10px;

  &::before {
    top: 0;
    left: 0;
    content: '';
    width: 100%;
    height: 100%;
    position: absolute;
    margin-top: -15px;
    margin-left: -15px;
    position: absolute;
    border-style: solid;
    border-radius: 100%;
    border-color: #444;
    border-width: 2px;
    border-right-color: #efefef;
    border-bottom-color: #efefef;
    animation: spin 1s linear infinite;
  }
`;
